<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Dedication" style="margin-top:3em;">To Jenny …</p>
<p class="ORIM-Dedication">and a pinch of powder to the wind for Somnus,</p>
<p class="ORIM-Dedication">the Father of Sleep.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Meyer_LotusCrew_4P_MD-1.vue?673c84c4